{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Zobrazit všechny možnosti",
  "Spoiler_Reveal_Tooltip": "Pro zobrazení klikněte",
  "VerticalEmbed_Event_Error_Subtitle": "Tato událost byla odstraněna, nahraďte ji jinou událostí.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetovat",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Položka je zabalena",
  "Spoiler_Reveal_Video_CTA": "Odkrýt video",
  "VerticalEmbed_Pricing_Plan": "Pouze plán",
  "Image_Expand_Button_AriaLabel": "Roztáhnout obrázek",
  "VerticalEmbed_From_Price": "Od",
  "Poll_Viewer_ShowAllResults_CTA": "Zobrazit všechny výsledky",
  "Spoiler_Reveal_Image_Placeholder": "Tento obrázek obsahuje spoiler",
  "VerticalEmbed_Ribbon": "Akce",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Posuvník hledání",
  "VerticalEmbed_Error_Subtitle": "Tato položka byla odstraněna, nahraďte ji jinou položkou.",
  "Poll_Viewer_Multiselect_Footer": "Můžete hlasovat pro více jak jednu odpověď.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Zobrazit další ovládací prvky zvuku",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Službu se nepodařilo načíst",
  "Fullscreen_Close_Button_AriaLabel": "Zavřít",
  "VerticalEmbed_Event_Fetch_Error_Title": "Událost se nepodařilo načíst",
  "UploadFile_Viewer_Loader": "Načítání {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Použít avatara",
  "Preview_ReadMore_Label": "Zjistit více",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Produkt se nepodařilo načíst",
  "Fullscreen_Shrink_Button_AriaLabel": "Zmenšit",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Objem",
  "Spoiler_Reveal_Gallery_Placeholder": "Tato galerie obsahuje spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Roztáhnout",
  "VerticalEmbed_Bookings_Button": "Rezervovat",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Zrušit ztlumení",
  "Spoiler_Reveal_Gallery_CTA": "Odkrýt galerii",
  "Poll_Viewer_ShowLess_CTA": "Zobrazit méně",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Ztlumit",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymně",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sledovat",
  "VerticalEmbed_Products_Button": "Koupit",
  "Poll_Viewer_Toast_Error_ServerDown": "Nepodařilo se připojit k serveru. Zkuste to později.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "Pro tuto odpověď hlasoval {{count}} uživatel",
  "Poll_Viewer_VoteCount": "Hlasů {{number}}",
  "VerticalEmbed_Events_Button": "Registrovat",
  "Spoiler_Reveal_Image_CTA": "Odkrýt obrázek",
  "Poll_Viewer_Toast_Error_Connection": "Internet není k dispozici. Zkontrolujte připojení.",
  "Poll_Viewer_Visibility_Owner_Footer": "Výsledky uvidíte pouze vy.",
  "VerticalEmbed_Booking_Error_Title": "Služba byla odstraněna",
  "VerticalEmbed_Product_Error_Title": "Produkt byl odstraněn",
  "VerticalEmbed_Fetch_Error_Subtitle": "Informace o položce nelze načíst.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Pro tuto odpověď hlasovalo uživatelů: {{count}}",
  "VerticalEmbed_Event_Error_Title": "Událost byla odstraněna",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Položka je rozbalena",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Toto video obsahuje spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Objevily se technické potíže. Zkontrolujte připojení a zkuste to znovu.",
  "VerticalEmbed_Fetch_Error_Title": "Položku se nepodařilo načíst",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Tento produkt byl odstraněn, nahraďte ho jiným produktem.",
  "VerticalEmbed_Booking_Error_Subtitle": "Tato služba byla odstraněna, nahraďte ji jinou službou.",
  "Preview_SeeFullPost_Label": "Zobrazit celý příspěvek",
  "UploadFile_Viewer_Download": "Stáhnout {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Objevily se technické potíže. Zkontrolujte připojení a zkuste to znovu.",
  "VerticalEmbed_Error_Button": "Nahradit",
  "VerticalEmbed_Error_Title": "Položka byla odstraněna",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Objevily se technické potíže. Zkontrolujte připojení a zkuste to znovu.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
